import { useState, useMemo, useCallback, useEffect, useContext } from "react";
import {
    Box,
    Stack,
    Typography,
    Card,
    Grid,
    CardContent,
} from "@mui/material";
import { useGridApiRef, getGridStringOperators } from "@mui/x-data-grid";
import Chart from "../../components/Chart"
import NodataImg from "../../assets/images/noData.png";
import { useDispatch, useSelector } from "react-redux";
import { CourseProgressApi } from "../../store/analytics/courseProgress";
import { ThemeContext } from '../../context/ThemeContext';
import dayjs from "dayjs";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";
import { AiOutlineBell } from 'react-icons/ai'
import { useNavigate } from "react-router-dom";


const courseColumns = [
    // {
    //     field: "id",
    //     headerName: "ID",
    //     width: 120,
    //     disableColumnMenu: true,
    //     filterable: false,
    //     sortable: false,
    //  disableColumnMenu: true,
    // },
    {
        field: "course_name",
        headerName: "Course Name",
        width: 250,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "course_id",
        headerName: "Course ID",
        width: 200,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "total_enrolled_users",
        headerName: "Total Enrolled Users",
        width: 200,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "total_likes",
        headerName: "Total Likes",
        width: 140,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "total_bookmarks",
        headerName: "Total Bookmarks",
        width: 160,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "completed_users",
        headerName: "Completed Users",
        width: 160,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "completion_pct",
        headerName: "Average Completion (%)",
        width: 140,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "language",
        headerName: "Language",
        width: 140,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "total_time_minutes",
        headerName: "Total Time (Minutes)",
        width: 200,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "average_time",
        headerName: "Average Time (Minutes)",
        width: 180,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    }

];


export default function CourseProgress({ graphData, region, state, loading, type, module, monthDaily, startDate, endDate, isMaskingEnabled, schoolType }) {
    const [activevsavgtimespent, setActiveVsAvgTimeSpent] = useState({ l1: true, l2: true });
    const [teacherRegister, setTeacherRegistration] = useState({ l1: true, l2: true, l3: true, l4: true });
    const apiRef = useGridApiRef();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [isDownload, setIsDownload] = useState(false)
    const CourseProgressTable = useSelector((state) => state?.CourseProgressTable);
    const { result: tableResult, loading: tableLoading, total } = CourseProgressTable;
    const [queryOptions, setQueryOptions] = useState({});
    const { paginationModel, setPaginationModel } = useContext(ThemeContext)

    const onFilterChange = useCallback((filterModel) => {
        setQueryOptions({ filterModel: { ...filterModel } });
    }, []);
    const toggleTeacherRegistration = useCallback((key) => {
        setTeacherRegistration(prevState => ({ ...prevState, [key]: !prevState[key] }));
    }, []);
    const toggleActiveVsAvgTimeSpent = useCallback((key) => {
        setActiveVsAvgTimeSpent(prevState => ({ ...prevState, [key]: !prevState[key] }));
    }, []);
    const getRowSpacing = useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);
    const handleSortModelChange = useCallback((sortModel) => {
        setQueryOptions({ sortModel: [...sortModel] });
    }, []);

    const transformGraphData = useMemo(() => {
        const chartData = Array.isArray(graphData?.monthly_by_month)
            ? graphData?.monthly_by_month.map(item => ({
                name: item.month || item.name,
                "Total Enrollments": item.total_enrollments || 0,
                "Total Likes": item.total_likes || 0,
                "Total Bookmarks": item.total_bookmarks || 0,
                "Total Certificates": item.total_certificates || 0,
                "Completion Rate": item.completion_rate || 0,
                "Popular Course": item.popular_course || "",
                "Popular Course Enrollments": item.popular_course_enrollments || 0,
            }))
            : [];
        return chartData;

    }, [graphData, type]);

    useEffect(() => {
        // console.log("isMaskingEnabled",isMaskingEnabled);
        const filterModel = queryOptions?.filterModel;
        const items = filterModel?.items;
        const firstItem = items && items.length > 0 ? items[0] : {};
        const quickFilterValues = filterModel?.quickFilterValues;
        const sortModel = queryOptions?.sortModel;
        let query
        if (sortModel?.length > 0) {
            query = {
                module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                sort_order: sortModel[0].sort || "desc",
                field: firstItem.field || '',
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        } else {
            query = {
                module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                field: firstItem.field || '',
                city: region,
                sort_order: "desc",
                state: state,
                start_date: startDate,
                end_date: endDate,
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        }
        dispatch(CourseProgressApi(query));
    }, [dispatch, queryOptions, paginationModel, region, state, module, startDate, endDate, isMaskingEnabled, schoolType]);

    // console.log("tableResult", tableResult);

    const handleCourseModuleTableRowClick = (params) => {
        console.log("params", params?.row?.id);
        navigate(`/get-analytics/course-progress/${params?.row?.id}`, {
            // courseName: params?.row?.course_name
            state: { courseName: params?.row?.course_name, tabIndex: 6 }
        })
    }

    return (
        <>
            <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center" justifyContent={"space-between"}>
                <Typography variant="h3">Course Progress</Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
                <Grid container spacing={1}>
                    {graphData?.total_data && Object.entries(graphData.total_data).map(([data, value], index) => {
                        return (
                            <Grid item xs={6} sm={6} md={6} lg={3} mb={1} key={index}>
                                <Box
                                    className='customCard1'
                                    sx={{
                                        transition: 'none !important',
                                        '&:hover': {
                                            transform: 'none !important',
                                        },
                                    }}
                                >
                                    <Stack direction='row' alignItems='center' spacing={1}>
                                        <Box sx={{ fontSize: 25 }}>
                                            <AiOutlineBell size={25} />
                                        </Box>
                                        <Stack>
                                            <Typography sx={{ textTransform: "capitalize" }}>{data.replaceAll("_", " ")}</Typography>
                                            <Typography variant='h4' fontWeight={600} title={data === "popular_course" && typeof value === 'string' && value.length > 5 ? value : ""}>
                                                {data === "popular_course" && typeof value === 'string' && value.length > 5 ? `${value.substring(0, 15)}...` : value}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Grid>
                        )
                    })}
                </Grid>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
                <Chart type={"line"} height={500} data={transformGraphData} module={'CourseProgress'} lineState={teacherRegister} />
            </Stack>
            <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center">
                <DataGridComponent
                    disableColumnMenu
                    disableColumnSorting
                    loading={tableLoading}
                    rowCount={total}
                    pageSize={paginationModel?.pageSize}
                    onPageSizeChange={(newPageSize) => {
                        setPaginationModel({
                            ...paginationModel,
                            pageSize: newPageSize,
                        })
                    }}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    sx={{
                        height: 500,
                        "& .MuiDataGrid-cell": {
                            cursor: "pointer",
                            fontSize: "15px",
                        },

                    }}
                    rows={tableResult}
                    getRowId={(r) => {
                        return module === "course" ? r['s.no'] : r['id']
                    }}
                    getRowSpacing={getRowSpacing}
                    columns={courseColumns}
                    onSortModelChange={handleSortModelChange}
                    onFilterModelChange={onFilterChange}
                    onRowClick={handleCourseModuleTableRowClick}
                    slots={{
                        noRowsOverlay: () => (
                            <Box className="noData">
                                <img src={NodataImg} alt="no data found" />
                            </Box>
                        ),
                        toolbar: (props) =>
                        (CustomGridToolbar({
                            ...props, moduleType: "CourseProgress",
                            queryOptions,
                            paginationModel,
                            isDownload,
                            setIsDownload,
                            permissionModule: "analytics_dashboard", apiUrl: apiRoutes.courseProgressCsvExport,
                            download_csv: true,
                            hasfilter: false,
                            hasSearch: false,
                            additionalQueryParams: {
                                city: region,
                                state,
                                ...(startDate !== undefined && { start_date: startDate }),
                                ...(endDate !== undefined && { end_date: endDate }),
                                download_csv: true,
                                school_type: schoolType,
                                page: paginationModel?.page + 1,
                                page_size: paginationModel?.pageSize,
                            },
                        })),
                    }}
                    slotProps={{
                        loadingOverlay: {
                            variant: 'linear-progress',
                            noRowsVariant: 'linear-progress',
                        },
                        toolbar: {
                            // showQuickFilter: true,
                            showQuickFilter: false,
                        },
                    }}
                />
            </Stack>
            <BackdropUI open={isDownload} />
        </>)
}

